import FieldFactory from '../factories/field-factory.js';
import Form from '../form.js';
import PromiseReducer from '../helpers/promise-reducer.js';

export default class CompositeFormField {
    constructor(parent, el) {
        this.parent = parent;
        this.form = parent instanceof Form ? parent : parent.form;
        this.el = el;
        this.buildFields();
    }

    buildFields() {
        this.fields = [...this.el.querySelectorAll('.form_field_composite, .form_field')]
            .filter((f) => f.parentElement.closest('.form_field_composite') === this.el)
            .map((f) => FieldFactory.build(this, f))
            .filter((f) => f);
    }

    id() {
        return this.el.dataset.id;
    }

    field(id) {
        return this.fields.find((f) => id === f.id());
    }

    getFields(parent) {
        return this.fields.filter((f) => parent.contains(f.el));
    }

    reset() {
        this.fields.forEach((f) => f.reset());
    }

    update(field, valid) {
        this.parent.update(field, valid);
    }

    enable() {
        this.fields.forEach((f) => f.enable());
    }

    disable() {
        this.fields.forEach((f) => f.disable());
    }

    disabled() {
        return this.fields.every((f) => f.disabled());
    }

    valid(silent) {
        return PromiseReducer.all(this.fields.map((f) => f.valid(silent)));
    }

    async focusOnFirstInvalid() {
        for (const field of this.fields) {
            const isValid = await field.valid(true);

            if (isValid) {
                continue;
            }

            await field.focusOnFirstInvalid();
            break;
        }
    }

    populated() {
        return PromiseReducer.all(this.fields.map((f) => f.populated()));
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    static is(el) {
        return el.classList.contains('form_field_composite');
    }
}
